/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabOrderDtoType = (typeof LabOrderDtoType)[keyof typeof LabOrderDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabOrderDtoType = {
  BLOOD_QUANTIFERON: 'BLOOD_QUANTIFERON',
  BLOOD_TSPOT: 'BLOOD_TSPOT',
  SPUTUM: 'SPUTUM',
  TUBERCULIN: 'TUBERCULIN',
  XRAY: 'XRAY',
} as const;
